import { TicketFieldsState } from "../types";



export const initialState: TicketFieldsState = {
  isTicketUpdating: false,
  isBulkExporting: false,
};